import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { showBulletinDialog, hideBulletinDialog } from '../store/actions/bulletinDialog.actions';

export const useBulletinDialog = () => {
  const dispatch = useDispatch();
  const savedResult = useSelector((state) => state.bulletinDialog.savedResult);
  const dialogs = useSelector((state) => state.bulletinDialog.dialogs);
  const pendingRequests = useRef(new Map());

  useEffect(() => {
    if (!savedResult) return;
    const onSaved = pendingRequests.current.get(savedResult.requestId);
    pendingRequests.current.delete(savedResult.requestId);
    onSaved?.(savedResult.bulletin);
  }, [savedResult]);

  useEffect(() => {
    const activeRequests = new Set(dialogs.map((dialog) => dialog.requestId));
    pendingRequests.current.forEach((_, requestId) => {
      if (!activeRequests.has(requestId)) pendingRequests.current.delete(requestId);
    });
  }, [dialogs]);

  const openBulletinDialog = useCallback(
    (options = {}) => {
      const { onSaved, ...dialogOptions } = options;
      const requestId = uuid();
      pendingRequests.current.set(requestId, onSaved);
      dispatch(showBulletinDialog({ ...dialogOptions, requestId }));
      return requestId;
    },
    [dispatch]
  );

  const closeBulletinDialog = useCallback(
    (requestId) => {
      pendingRequests.current.delete(requestId);
      dispatch(hideBulletinDialog(requestId));
    },
    [dispatch]
  );
  return { openBulletinDialog, closeBulletinDialog };
};
